import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	confirm: {
		id: 'issue-field-cmdb-object.action-buttons.confirm',
		defaultMessage: 'Confirm',
		description: 'Button to confirm any edits made to a CMDB field',
	},
	cancel: {
		id: 'issue-field-cmdb-object.action-buttons.cancel',
		defaultMessage: 'Cancel',
		description: 'Button to cancel any edits made to a CMDB field',
	},
});
